import { ShortUserListItemDto } from './userConfig'

export type NoteOverviewDto = {
    id: string
    content: string
    isPrivate: boolean
    createdByAuthor: ShortUserListItemDto
    createdAt: string
    updatedByAuthor: ShortUserListItemDto
    updatedAt: string
    revisionCount: number
}

export type NoteMutationDto = {
    content: string
    authorId: string
    fileId: string
    isPrivate?: boolean
}

export enum NoteAction {
    GetOverview = 'GET_NOTE_OVERVIEW',
    Add = 'ADD_NOTE',
    Update = 'UPDATE_NOTE',
    Delete = 'DELETE_NOTE',
    ResetOverview = 'RESET_NOTE_OVERVIEW',
    OverviewSettings = 'NOTE_OVERVIEW_SETTINGS',
}
